import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Application: {
    id: 'label_application',
    defaultMessage: 'Application',
  },
  SortLabel: {
    id: 'label_sort_by_folder_position',
    defaultMessage: 'Sort by folder order',
  },
  SortHelp: {
    id: 'help_sort_by_folder_position',
    defaultMessage:
      'If not selected, occasions are sorted by start date ascending.',
  },
  ShowMore: {
    id: 'Show more',
    defaultMessage: 'Show more',
  },
});
